"use client";

import useScrollTrigger from "@mui/material/useScrollTrigger";

const WithScrollTrigger = ({
    threshold,
    disableHysteresis,
    children,
}: {
    threshold: number;
    disableHysteresis?: boolean;
    children: React.ReactNode;
}) => {
    const trigger = useScrollTrigger({ threshold, disableHysteresis });

    if (!trigger) return null;

    return <>{children}</>;
};

export default WithScrollTrigger;
